module.exports = __webpack_public_path__ + "img/rate_onsite.324b0041.jpg";